import { motion } from "framer-motion";

const draw = (delay = 0) => ({
  initial: { pathLength: 0, opacity: 0 },
  animate: { pathLength: 1, opacity: 1 },
  transition: { duration: 1.4, delay, ease: "easeInOut" },
});

export const Star = ({ className = "", color = "#FFFFFF", stroke = "#4A1580" }) => (
  <motion.svg viewBox="0 0 50 50" className={className} aria-hidden
    animate={{ rotate: [0, 15, -10, 0], scale: [1, 1.15, 0.95, 1] }}
    transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}>
    <path d="M25 2 L30 19 L48 25 L30 31 L25 48 L20 31 L2 25 L20 19 Z" fill={color} stroke={stroke} strokeWidth="2.5" strokeLinejoin="round" />
  </motion.svg>
);

export const Spiral = ({ className = "", color = "#E4D2F7" }) => (
  <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden>
    <motion.path d="M50 50 m0 -4 a4 4 0 1 1 -4 4 a10 10 0 1 1 10 10 a18 18 0 1 1 -18 -18 a26 26 0 1 1 26 26 a34 34 0 1 1 -34 -34"
      stroke={color} strokeWidth="4" strokeLinecap="round" {...draw(0.6)} />
  </svg>
);

export const Arrow = ({ className = "", color = "#FFFFFF" }) => (
  <svg viewBox="0 0 120 80" className={className} fill="none" aria-hidden>
    <motion.path d="M110 10 C 80 6, 40 20, 30 62" stroke={color} strokeWidth="4" strokeLinecap="round" {...draw(1)} />
    <motion.path d="M16 48 L30 66 L44 50" stroke={color} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" {...draw(2)} />
  </svg>
);

export const BadgeCircle = ({ text = "خرابيش • أكاديمي • موشن • أنيميشن • ", className = "" }) => (
  <div className={`relative ${className}`} aria-hidden>
    <svg viewBox="0 0 200 200" className="kh-spin-slow w-full h-full">
      <defs>
        <path id="kh-circle" d="M100,100 m-78,0 a78,78 0 1,1 156,0 a78,78 0 1,1 -156,0" />
      </defs>
      <text fill="#FFFFFF" fontSize="17" fontFamily="El Messiri" letterSpacing="2">
        <textPath href="#kh-circle">{text}{text}</textPath>
      </text>
    </svg>
  </div>
);

export const Floater = ({ children, className = "", delay = 0 }) => (
  <motion.div className={className} animate={{ y: [0, -12, 0], rotate: [-3, 3, -3] }}
    transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut", delay }}>
    {children}
  </motion.div>
);
